import Image from 'next/image'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { FadeInWhenVisible } from '../FadeInWhenVisible'
import { IQuotesCarousel } from './QuotesCarousel'
import classes from './quotesCarousel.module.scss'
import React, { PropsWithChildren } from 'react'

interface SlideComponentProps  {
  item: IQuotesCarousel
}

const SlideComponent: React.FC<PropsWithChildren<SlideComponentProps>> = ({ item }) => {
  const isTablet = useMediaQuery('(max-width: 1023px)')

  return !item?.picture ? null : (
    <div
      className={classes.slide}
    >
      <div className={classes.innerSlide}>
        <div
          className={classes.slideText}>
          <FadeInWhenVisible animation="easySlidingTopFadeIn" delay={0.2}>
            <p className={classes.slideDescriptionText}>
              <span className={classes.textHighlight}>
                {item.description}
              </span>
            </p>
          </FadeInWhenVisible>
          {item?.brand && !isTablet && (
            <FadeInWhenVisible animation="easySlidingTopFadeIn" delay={0.3}>
              <div className={classes.slideBrandContainer}>
                <img className={classes.brandImage} src={item.brand} alt="logo"/>
              </div>
            </FadeInWhenVisible>
          )}
        </div>
        <div className={classes.slideImageContainer}>
          <FadeInWhenVisible animation="easySlidingTopFadeIn" delay={0.4}>
            <div className={classes.imageCircleContainer}>
              <Image
                width={isTablet? 500 : 2007}
                height={isTablet? 500 : 2092}
                className={classes.svgCutImage}
                src={item.picture} alt="carousel description" />
            </div>
          </FadeInWhenVisible>
        </div>
      </div>
      {item?.brand && isTablet && (
        <div className={classes.floatingBrand}>
          <FadeInWhenVisible animation="easySlidingTopFadeIn" delay={0.3}>
            <div className={classes.slideBrandContainer}>
              <img className={classes.brandImage} src={item.brand} alt="logo"/>
            </div>
          </FadeInWhenVisible>
        </div>
      )}
    </div>
  )}

export default SlideComponent
